/**
 * Converts URLs in text into clickable links
 * @param {string} text - The text to process
 * @param {string} messageId - Unique identifier for keying React elements
 * @returns {Array} Array of text fragments and link elements
 */
export function linkifyUrls(text, messageId = '') {
  if (!text) return text;
  
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  let parts = [];
  let lastIndex = 0;
  let urlKey = 0;
  
  text.replace(urlRegex, (match, url, offset) => {
    // Add text before URL
    if (offset > lastIndex) {
      parts.push(text.substring(lastIndex, offset));
    }
    
    // Add clickable URL
    parts.push(
      <a
        key={`url-${messageId}-${urlKey++}`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-400 hover:text-blue-300 underline break-all"
        onClick={(e) => e.stopPropagation()}
      >
        {url}
      </a>
    );
    
    lastIndex = offset + url.length;
    return match;
  });
  
  // Add remaining text after last URL
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }
  
  // If no URLs found, return original text
  return parts.length === 0 ? text : parts;
}
